import type { RouteMonitoringVisit } from '@/pages/Business/pages/Monitoring/models';
import { asRecord, pickStr } from './object-pickers';

export function normalizeCommerceBlock(
  raw: unknown
): RouteMonitoringVisit['commerce'] {
  const o = asRecord(raw);
  if (!o) return null;
  const id = pickStr(o, 'id', 'id');
  const name = pickStr(o, 'name', 'name');
  if (!name && !id) return null;
  return {
    id: id ?? undefined,
    name: name ?? undefined,
  };
}
